import React, { useRef, useState } from 'react';
import { sopFire } from '../../../utils/sopSwal';
import StageChrome from '../components/StageChrome';
import useGameTimer from '../components/useGameTimer';
import { ASSET, reportOnSubmit, submitStage } from '../../../utils/sopGame';
import '../stages.css';

const CIPHERS = ['LZGZSLG FZMCGH', 'RTAGZRG BGZMCQZ ANRD', 'AGZFZS RHMF'];
const ANSWERS = ['mahatma gandhi', 'subhash chandra bose', 'bhagat singh'];

const HINT =
  "Secret of the Patriots each letter is shifted by a fixed number of positions in the alphabet. For example, 'A' becomes 'B', 'B' becomes 'C', 'C' becomes 'D', and so on. By applying the same shift of 25 positions, you can decode the message to reveal the original names.";

export default function Stage1({ user, onComplete, reportId }) {
  const [answers, setAnswers] = useState(['', '', '']);
  const [status, setStatus] = useState(['', '', '']);
  const [score, setScore] = useState(0);
  const [sending, setSending] = useState(false);
  const scored = useRef([false, false, false]);
  const timeeRef = useRef('00:00:00');
  const { display } = useGameTimer(0, (hms) => {
    timeeRef.current = hms;
  });

  const onChange = (i, val) => {
    const next = [...answers];
    next[i] = val;
    setAnswers(next);
    const trimmed = val.trim().toLowerCase();
    if (!trimmed) {
      setStatus((s) => {
        const n = [...s];
        n[i] = '';
        return n;
      });
      return;
    }
    const ok = trimmed === ANSWERS[i];
    setStatus((s) => {
      const n = [...s];
      n[i] = ok ? 'correct' : 'wrong';
      return n;
    });
    if (ok && !scored.current[i]) {
      scored.current[i] = true;
      setScore((p) => p + 1);
    }
  };

  const submit = async () => {
    if (sending) return;
    if (answers.some((a) => !a.trim())) {
      sopFire({ text: 'Please fill all fields before submitting.' });
      return;
    }
    let points1 = 0;
    answers.forEach((a, i) => {
      if (a.trim().toLowerCase() === ANSWERS[i]) points1 += 1;
    });
    const points = score;
    setSending(true);
    try {
      const res = await submitStage(user, {
        points,
        points1,
        round: 1,
        timee: timeeRef.current,
        reportId,
      });
      await reportOnSubmit(user, { points, timee: timeeRef.current, round: 1, reportId });
      const msg =
        points >= 1
          ? "Congratulations! Now that you have identified the names of the fighters on which this diary is based, let's move forward to uncover more truths"
          : "Unfortunately, the names of the fighters you identified are incorrect. Let's move forward to the next stage and uncover more discoveries";
      await sopFire({ text: msg });
      if (res.code === 'demo') {
        /* continue anyway in app */
      }
      onComplete();
    } catch (err) {
      console.error(err);
      sopFire({ text: err.message || 'Submit failed' });
      setSending(false);
    }
  };

  return (
    <StageChrome
      title="Decipher the codes to identify prominent freedom fighters from the Independence"
      score={score}
      timerDisplay={display}
      hint={
        <button
          type="button"
          className="sop-hint-btn"
          onClick={() => sopFire({ text: HINT })}
        >
          <img src={ASSET.img('hint.png')} alt="Hint" />
        </button>
      }
    >
      <div className="sop-cipher-grid">
        {CIPHERS.map((c, i) => (
          <div className="sop-cipher-row" key={c}>
            <input className="sop-cipher" readOnly value={c} />
            <input
              className={`sop-input ${status[i]}`}
              value={answers[i]}
              placeholder="Type Here"
              readOnly={status[i] === 'correct'}
              onChange={(e) => onChange(i, e.target.value)}
              autoComplete="off"
            />
          </div>
        ))}
      </div>
      <div className="sop-actions">
        <button type="button" className="sop-img-btn" disabled={sending} onClick={submit}>
          <img src={ASSET.img('submit.png')} alt="Submit" />
        </button>
      </div>
    </StageChrome>
  );
}
